import { collection, doc, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import SalesGame from "../../../classes/SalesGame";
import { db, functions } from "../../../boot/firebase";

// Cloud function to notify participants when a game is activated
const notifySalesGameParticipants = httpsCallable(
  functions,
  "notifySalesGameParticipants"
);

export const GET_SALES_GAME = ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: SalesGame,
    path: SalesGame.getPath(id),
    stateKey: "salesGames",
    stateID: id,
    id,
  });
};

export const GET_SALES_GAMES = ({ dispatch }, { where, limit, pagination }) => {
  return dispatch("GET_COLLECTION", {
    converter: SalesGame,
    path: SalesGame.getPath(),
    stateKey: "salesGames",
    where,
    limit,
    pagination,
  });
};

export const LISTEN_SALES_GAME = (
  { dispatch },
  { id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: SalesGame,
    path: SalesGame.getPath(id),
    stateKey: "salesGames",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_SALES_GAMES = (
  { dispatch },
  { where, pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: SalesGame,
    path: SalesGame.getPath(),
    stateKey: "salesGames",
    where,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_SALES_GAME = async (
  { commit, state },
  { id, data, notifyParticipants = false }
) => {
  const now = new Date();
  const user = state.user;

  // Check if this is activating a game (for notification purposes)
  let wasInactive = true;
  if (id) {
    const existingDoc = await getDoc(doc(db, SalesGame.getPath(id)));
    if (existingDoc.exists()) {
      wasInactive = !existingDoc.data().active;
    }
  }

  // Create a SalesGame instance
  const game = new SalesGame(id, data);

  if (!id) {
    // Creating new - generate ID
    game.data.created = now;
    game.data.createdBy = user.id;

    const ref = doc(collection(db, SalesGame.getPath()));
    game.id = ref.id;

    await setDoc(ref, game.toFirestore());
  } else {
    // Updating existing
    game.data.modified = now;
    game.data.modifiedBy = user.id;

    await setDoc(doc(db, SalesGame.getPath(id)), game.toFirestore());
  }

  // Update local state
  commit("SET", { stateKey: "salesGames", stateID: game.id, doc: game });

  // Notify participants if game was just activated
  const justActivated = wasInactive && game.data.active;
  if (justActivated || notifyParticipants) {
    try {
      await notifySalesGameParticipants({ gameId: game.id });
    } catch (error) {
      console.error("Failed to notify participants:", error);
    }
  }

  return game;
};

export const DELETE_SALES_GAME = ({ commit }, id) => {
  return deleteDoc(doc(db, SalesGame.getPath(id))).then(() =>
    commit("REMOVE", { stateKey: "salesGames", id })
  );
};
